module.exports = __webpack_public_path__ + "static/prestashop-967a6dbfe390fa3c80432caa1e5d8e4c.svg";